import { render, staticRenderFns } from "./ExceedingRoadSpeedLimit.vue?vue&type=template&id=daa81a5c&"
import script from "./ExceedingRoadSpeedLimit.vue?vue&type=script&lang=js&"
export * from "./ExceedingRoadSpeedLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports